const Transaction = {
  path: '/transaction',
  name: 'transaction',
  component: () => import('../../views/Transaction/transaction.vue'),
};

module.exports = {
  Transaction,
};
